<div class="splash-screen" *ngIf="showSplash" [class.exit-animation]="isAnimatingOut">
  <div class="logo-container">
    <!-- <div class="single-expanding-ring"></div> -->

    <svg width="162" height="51" viewBox="0 0 162 51" fill="none" xmlns="http://www.w3.org/2000/svg" class="arkik-text">
      <path
        d="M45.8018 50.5557H36.3018L32.3906 39.1826H13.332L9.35449 50.5557H0L17.8789 1.4043H27.9316L45.8018 50.5557ZM70.7158 14.9062V24.3643H68.2061C66.4129 24.3323 64.6301 24.6435 62.9521 25.2803C61.4251 25.8821 60.1537 26.9994 59.3555 28.4404C58.513 29.9396 58.0918 32.0221 58.0918 34.6885V50.5557H49.1475V15.7285H57.1016L57.9365 22.2578C59.1573 20.0529 60.9253 18.203 63.0674 16.8887C65.3825 15.5218 68.0322 14.8347 70.7158 14.9062ZM83.0049 29.8447L95.2891 15.7285H105.895L91.7275 31.5957L108.201 50.5557H97.0352L83.0049 33.0713V50.5557H74.0654V0H83.0049V29.8447ZM120.283 50.5557H111.348V15.7285H120.283V50.5557ZM135.948 29.8447L148.232 15.7285H158.838L144.667 31.5957L161.136 50.5557H149.965L135.948 33.0713V50.5557H127V0H135.948V29.8447ZM15.7754 32.1602H29.9473L22.8281 11.7158L15.7754 32.1602ZM111.804 1.44434C114.14 -0.474802 117.496 -0.474812 119.832 1.44434C120.869 2.3804 121.443 3.72843 121.401 5.12891C121.436 6.54063 120.863 7.89882 119.828 8.85352C118.733 9.85239 117.293 10.38 115.815 10.3242C114.336 10.3799 112.894 9.85017 111.799 8.84863C110.769 7.89336 110.198 6.53763 110.234 5.12891C110.193 3.72843 110.767 2.3804 111.804 1.44434Z"
        fill="#2D2D2D"
      />
    </svg>

    <svg width="62" height="50" viewBox="0 0 62 50" fill="none" xmlns="http://www.w3.org/2000/svg" class="ai-text">
      <path
        d="M46.1426 50H37.0713L32.9248 38.2139H13.0752L8.92871 50H0L18.2861 0H27.8574L46.1426 50ZM61.5918 50H53.0205V0H61.5918V50ZM15.4619 31.4287H30.5381L23 10L15.4619 31.4287Z"
        fill="url(#paint0_radial_153_3808)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_153_3808"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.8643 49.7222) rotate(-65.3583) scale(59.9604 78.8464)"
        >
          <stop stop-color="#00FAE5" />
          <stop offset="0.539807" stop-color="#0096FA" />
          <stop offset="1" stop-color="#5100FF" />
        </radialGradient>
      </defs>
    </svg>
  </div>
</div>

<ng-container *ngIf="conversationHistory$ | async as conversationHistory">
  <talk-to-your-data-chatbot-shell
    [focusInputTrigger]="focusInputTrigger"
    [quickQuestions]="quickQuestions$ | async"
    [activeConversation]="activeConversation$ | async"
    [conversationHistory]="conversationHistory"
    [savedConversations]="savedConversations$ | async"
    [selectedConversationId]="selectedConversationId$ | async"
    [sendingMessage]="sendingMessage$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async"
    [userProfile]="userProfile$ | async"
    (conversationSelected)="onConversationSelected($event)"
    (conversationSaved)="onConversationSaved($event)"
    (conversationUnsaved)="onConversationUnsaved($event)"
    (conversationRenamed)="onConversationRenamed($event)"
    (conversationDeleted)="onConversationDeleted($event)"
    (suggestionSelected)="onSuggestionSelected($event)"
    (messageSubmitted)="onMessageSubmitted($event)"
    (stopRequested)="onStopRequested()"
    (newChatClicked)="onNewChat(conversationHistory)"
  ></talk-to-your-data-chatbot-shell>
</ng-container>

<nz-modal
  [nzVisible]="showConversationLimitModal"
  [nzWidth]="540"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  [nzCentered]="true"
  (nzOnCancel)="closeConversationLimitModal()"
>
  <ng-container *nzModalContent>
    <div class="conversation-limit-modal" data-testid="conversation-limit-modal" role="alert">
      <cwc-icon
        class="conversation-limit-modal__icon"
        data-testid="conversation-limit-modal-icon"
        name="warning"
        size="52px"
        color="bright-blue"
        aria-hidden="true"
      ></cwc-icon>
      <p class="conversation-limit-modal__message">
        {{ 'certify.chatbot.conversationLimit.message' | translate }}<br />
        {{ 'certify.chatbot.conversationLimit.instruction' | translate }}
      </p>
      <button
        class="conversation-limit-modal__continue"
        data-testid="conversation-limit-modal-continue"
        type="button"
        (click)="closeConversationLimitModal()"
      >
        {{ 'certify.chatbot.conversationLimit.continue' | translate }}
      </button>
    </div>
  </ng-container>
</nz-modal>
